
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/[brandOrCategoriesSlug]/[...categories]",
      function () {
        return require("private-next-pages/[slug]/[brandOrCategoriesSlug]/[...categories].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/[brandOrCategoriesSlug]/[...categories]"])
      });
    }
  